<div class="fontSize row mb-3" style="margin-top: 10px;">
  <div class="col-12 col-md-12 mt-1" style="display: flex;">
    <button type="button" class="btn btn-light" [ngClass]="{'active' : isScreenrecord}"
      (click)="showScreenrecordtab()"><i class="fa fa-video-camera"
        style="color: darkred; margin-right: 5px;"></i>{{"Screen Record" |
      translate}}</button>
    <button type="button" class="btn btn-light" [ngClass]="{'active' : isDraft}" (click)="showScreenshotDrafttab()"><em
        class="fa fa-gear fa-spin" style="color: #12c9e9;"></em>&nbsp;
      {{"Draft" | translate}}</button>
  </div>
</div>





<div class="fontSize">
  <!-- <div style="display: flex ;border:1px solid #c3b8b8;   border-radius: 10px;">
  <button type="button" class="btn btn-outline-success btn-lg" title="Start" (click)="StartRecord()">
    <i class="fa fa-play-circle"></i>
  </button>
  <button type="button" class="btn btn-outline-danger btn-lg" title="Pause" (click)="PauseRecord()">
    <i class="fa fa-pause-circle"></i>
  </button>
  <button type="button" class="btn btn-outline-warning btn-lg" title="Stop" (click)="StopRecord()">
    <i class="fa fa-stop-circle"></i>
  </button>
</div> -->

  @if (isScreenrecord) {
  <div>
    <div class="col-12 col-md-12 widget-container fluid-height">
      <div class="col-12 col-md-12 stf-screenrecord">
        <div class="row mt-2">
          <!-- <div class="col-md-3"> -->
          <div style="display: flex ;">
            <div class="vidiobutton" style="display: flex; border: 1px solid #c3b8b8; border-radius: 10px;">
              <button id="Start" type="button" class="btn btn-outline-success btn-lg" title="Start"
                [disabled]="isButtonDisabled" (click)="StartRecord()">
                <i [ngClass]="iconClass"></i>
              </button>
              <button type="button" class="btn btn-outline-danger btn-lg" [title]="isPaused ? 'Resume' : 'Pause'"
                [disabled]="isPauseButtonDisabled" (click)="toggleRecord()">
                <i [class]="isPaused ? 'fa fa-play-circle' : 'fa fa-pause-circle'"></i>
              </button>
              <button type="button" class="btn btn-outline-warning btn-lg" title="Stop" (click)="StopRecord()"
                [disabled]="StopRecordbutton">
                <i class="fa fa-stop-circle"></i>
              </button>
            </div>
            @if (videoRecords.length!=0) {
            <button class="btn btn-sm btn-primary" style="margin-left: 15px;" title="Download screenrecord"
              (click)="DownloadAll()">
              <i class="fa fa-download"></i><span>{{"Download All" | translate}}</span>
            </button>
            }
            @if (videoRecords.length!=0) {
            <button title="Delete All" class="btn btn-danger" style="margin-left: 5px;"
              (click)="DeleteAllVidioes()">{{"Discard All" | translate}}</button>
            }
          </div>
          <!-- </div> -->
          <!-- <div class="col-md-4">
        <div class="pull-right">
          <input type="range" [(ngModel)]="value" id="test" min="0" max="100" step="10"
            (click)="resizeImageOfIos({ max: 100, step: 1 })" [disabled]="screenshots.length == 0"
            *ngIf="device.platform == 'iOS' || device.platform == 'Android'" class="zoom-range">
        </div>
      </div> -->
        </div>
        <div class="widget-content padded">
          @if (videoRecords.length == 0) {
          <div>
            <div class="nothing-to-show">
              <i class="fa fa-4x fa-video-camera" ng-class="icon"></i>
              <p>{{"No Video taken" | translate}}</p>
              <span class="helper-text">{{"Click the " | translate}}<strong>{{"Play" | translate}}</strong>{{" button to
                record your first video!" | translate}}</span>
            </div>
          </div>
          }
          @if (videoRecords.length != 0) {
          <ul class="screenrecord-icon-view clear-fix selectable" style="margin-top: 15px; overflow: auto;">
            <li class="screenrecord-icon-item" style="margin-right: 5px;">
              <br />
              @for (video of videoRecords ; track video; let i = $index) {
              <div style="margin-bottom:5px ; text-align: center;     margin-right: 5px;">
                <div>
                  <a class="fa fa-download" style="font-size: 20px" target="_blank"
                    (click)=DownloadscreenRecord(video.url,video.recorderName) title="Download On Local"></a>&nbsp;
                  <a class="fa fa-trash" style="font-size: 20px; color: red" (click)=DeleteScreenRecord(i)
                    title="Delete"></a>
                  <!-- <a class="fa fa-save" style="font-size: 20px; color: darkblue ;margin-left: 9px; " (click)=SaveBackupScreenrecord(i) title="SaveAs backup"></a> -->
                  <!-- <a
                  class="fa fa-save"
                  [ngClass]="{ 'disabled': isBackupDisabled[i] }"
                  style="font-size: 20px; color: darkblue; margin-left: 9px; cursor: pointer;"
                  (click)="SaveBackupScreenrecord(i)"
                  [title]="isBackupDisabled[i] ? 'Backup already saved' : 'Save As Backup'"
                  >
                  Save As backup
                </a> -->
                  <a class="fa fa-save" [ngClass]="{ 'disabled': isBackupDisabled[i] }"
                    style="font-size: 20px; color: darkblue; margin-left: 9px;" (click)="SaveBackupScreenrecord(i)"
                    [title]="isBackupDisabled[i] ? 'Backup already saved' : 'Save As Backup'"></a>
                </div>
                <video [src]="video.url" controls width="200" height="300"></video>
                <h6> {{ device.serial }}</h6>
                <h6> {{video.date}}</h6>
                @if (!editMode[i]) {
                <div (click)="editMode[i] = true" title="edit recorderName ">
                  <h6>{{ video.recorderName || 'Unnamed' }}({{ i + 1 }})</h6>
                </div>
                }
                <!-- Edit mode  open zala-->
                @if (editMode[i]) {
                <div style="display: flex;">
                  <input [(ngModel)]="video.recorderName" (blur)="saveName(i)" placeholder="Edit Name"
                    style="height: 28px;" />
                  <button class="btn btn-success" (click)="saveName(i)" style="margin-left: 5px;">Save</button>
                  <button class="btn btn-danger " (click)="editMode[i] = false"
                    style="margin-left: 5px;">Cancel</button>
                </div>
                }
              </div>
              }
              <!-- <h6>{{ shot.body.date | date:'HH:mm:ss' }}</h6>
          <a class="fa fa-save" style="font-size: 20px" target="_blank" [href]="shot.body.href"
          download="screenshot.png"></a>&nbsp;
          <a class="fa fa-trash" style="font-size: 20px; color: red" (click)="removeScreenShot(i)"></a>
          <a [href]="shot.body.href" target="_blank" download="screenshot.png">
            <img class="screenshot-image resizeIOS"
              src="{{ shot.body.href + shotSizeParameter(480, 1) }}"
              srcset="{{ shot.body.href + shotSizeParameter(480, 2) }} 2x" />
          </a> -->
            </li>
          </ul>
          }
        </div>
      </div>
    </div>
  </div>
  }
  @if (isDraft) {
  <div>
    <div class="col-12 col-md-12 widget-container fluid-height">
      <div class="stf-Screenrecord">
        <div class="row">
          <div class="col-4 col-md-4">
            <button class="btn btn-sm btn-primary" (click)="BackupScreenrecord()">
              <i class="fa fa-folder"></i>
              <span>&nbsp;{{"Backup Screenrecord" | translate}}</span>
            </button>
          </div>
          @if (newArray.length > 0) {
          <div class="col-8 col-md-8" style="display: flex;">
            <a class="btn btn-outline-success" title="Save" (click)="downloadAllBackup()">
              <i class="fa fa-download"></i>
              <span>&nbsp;{{"Save All" | translate}}</span>
            </a>
            <button class="btn btn-sm btn-outline-danger" style="margin-left: 15px;" title="Discard"
              (click)="DeleteAllVidioesBackup()">
              <i class="fa fa-trash"></i>
              <span>&nbsp;{{"Discard All" | translate}}</span>
            </button>
          </div>
          }
        </div>
        @if (newArray.length == 0) {
        <div class="widget-content padded">
          <div class="nothing-to-show">
            <i class="fa fa-4x fa-video-camera"></i>
            <p>{{"No screenrecord taken" | translate}}</p>
          </div>
        </div>
        }
        <ul class="screenshots-icon-view clear-fix selectable">
          @for (vidioshot of newArray; track vidioshot; let i = $index) {
          <li class="screenshots-icon-item" style="display: block;">
            <!-- <h5>{{ device.name }}</h5> -->
            <!-- <a class="fa fa-save" style="font-size: 20px" target="_blank"(click) =DownloadscreenRecordBackup(vidioshot) title="DownloadscreenRecordOnLocal" ></a>&nbsp;
              <a class="fa fa-trash" style="font-size: 20px; color: red" (click) =DeleteScreenRecordBackup(i) title="DeleteScreenRecordBackup"></a> -->
            <!-- <a class="fa fa-save" style="font-size:20px" target="_blank" [href]="shot" -->
            <!-- download="screenshot.png"></a> -->
            <!-- <a class="fa fa-trash" style="font-size:20px" color="red" -->
            <!-- ></a>&nbsp; -->
            <!-- <a [href]="shot" target="_blank" download="screenshot.png"></a> -->
            <!--
          <a
            class="fa fa-download"
            style="font-size:20px"
            [href]="vidioshot"
            download="video-{{i}}.webm"
            title="Download Video">
            Download Video
          </a>&nbsp; -->
            <!-- <a class="fa fa-save" style="font-size:20px"  [href]="vidioshot"
        [download]="vidioshot"></a> -->
            <div style="display: flex ;justify-content: center;">
              <button class="fa fa-save" style="font-size:20px" (click)="downloadVideo(vidioshot,i)">
              </button>
              <a class="fa fa-trash" style="font-size:20px ; color: red;"
                (click)="removeDraftScreenRecord(i)"></a>&nbsp;
            </div>
            <video [src]="vidioshot" controls width="200" height="300"></video>
          </li>
          }
        </ul>
      </div>
    </div>
  </div>
  }
</div>

<ng-template #start_session let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to Start Recording??" | translate}}</p>
    <div class="alert-actions" style="display: flex; justify-content: center;">
      <button type="button" class="btn btn-success" (click)="StartRecordConfirm()">{{"Yes, Proceed" |
        translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #stop_session let-modal>
  <div class="modal-body" style="text-align: center;">
    <span style="overflow-wrap: break-word;">{{"Recording is Stopped!" | translate}}</span>
  </div>
  <div class="alert-actions" style="justify-content: center;top: 0;bottom: 0;left: 0;right: 0;margin: auto;">
    <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
  </div>
</ng-template>

<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions" style="text-align: center; margin-left: 101px;">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #delete_all_vidioes let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to delete all videos" | translate}}</p>
    <div class="alert-actions">
      <button style="display: inline;" type="button" class="btn btn-success" (click)="removeAllScreenRecord();">{{"Yes,
        Proceed" | translate}}</button>&nbsp;
      <button style="display: inline" type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, cancel" |
        translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #delete_all_vidioes_backup let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to delete all videos" | translate}}</p>
    <div class="alert-actions">
      <button style="display: inline;" type="button" class="btn btn-success" (click)="draftClearRecord();">{{"Yes,
        Proceed" | translate}}</button>&nbsp;
      <button style="display: inline" type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" |
        translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #downloadAllVidioes let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to Download all videos" | translate}}</p>
    <div class="alert-actions">
      <button style="display: inline;" type="button" class="btn btn-success"
        (click)="DownloadAllscreenRecord();">{{"Yes, Proceed" | translate}}</button>&nbsp;
      <button style="display: inline" type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" |
        translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #downloadAllBkp let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to Download all videos " | translate}}</p>
    <div class="alert-actions">
      <button style="display: inline;" type="button" class="btn btn-success" (click)="downloadAllVideo();">{{"Yes,
        Proceed" | translate}}</button>
      <button style="display: inline" type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" |
        translate}}</button>
    </div>
  </div>
</ng-template>